<div class="bulk-processing-dialog">
  <div class="dialog-header">
    <h2>Processing Tiles</h2>
    <button
      type="button"
      class="close-button"
      (click)="onClose(statistics().created)"
    >
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>

  <div class="dialog-content">
    <div class="table-wrapper">
      <motn-sort-table
        [table$]="table$"
        [disableUrlUpdate]="true"
        (renderedRows$)="tableRowsRendered($event)"
      ></motn-sort-table>
    </div>
  </div>

  <div class="dialog-footer">
    <div class="footer-top">
      <div class="statistics-row">
        <div class="stat-item">
          <span class="stat-value">{{ statistics().total }}</span>
          <span class="stat-label">Total</span>
        </div>
        <div class="stat-item">
          <span class="stat-value">{{ statistics().queued }}</span>
          <span class="stat-label">Queued</span>
        </div>
        <div class="stat-item">
          <span class="stat-value">{{ statistics().processing }}</span>
          <span class="stat-label">Processing</span>
        </div>
        <div class="stat-item success">
          <span class="stat-value">{{ statistics().created }}</span>
          <span class="stat-label">Completed</span>
        </div>
        <div class="stat-item warning">
          <span class="stat-value">{{ statistics().warnings }}</span>
          <span class="stat-label">Warnings</span>
        </div>
        <div class="stat-item error">
          <span class="stat-value">{{ statistics().errors }}</span>
          <span class="stat-label">Errors</span>
        </div>
      </div>

      <div class="progress-row">
        <div class="progress-section">
          <div class="progress-bar-large">
            <div class="progress-fill" [style.width.%]="statistics().progressPercentage"></div>
          </div>
          <span class="progress-text">{{ statistics().progressPercentage }}%</span>

        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="control-buttons">
        @if (currentService.isProcessing()) {
          <button
            type="button"
            class="white orange small"
            (click)="pauseProcessing()"
          >
            <i class="fa-regular fa-pause"></i>
            Pause
          </button>
        } @else if (currentService.isPaused()) {
          <button
            type="button"
            class="white green small"
            (click)="currentService.resumeProcessing()"
          >
            <i class="fa-regular fa-play"></i>
            Resume
          </button>
        }

        @if (hasRetryableItems && currentService.isCompleted()) {
          <button
            type="button"
            class="white indigo small"
            (click)="retryFailed()"
          >
            <i class="fa-regular fa-rotate-right"></i>
            Retry Failed
          </button>
        }

        @if (!isConfigurationMode && statistics().created > 0 && currentService.isCompleted()) {
          <button
            type="button"
            class="white red small"
            (click)="deleteAllCreatedTiles()"
          >
            <i class="fa-regular fa-trash"></i>
            Delete All Created
          </button>
        }

        @if (isConfigurationMode && statistics().created > 0 && bulkTileConfigService.isCompleted()) {
          <button
            type="button"
            class="white yellow small"
            (click)="revertUpdates()"
          >
            <i class="fa-regular fa-rotate-left"></i>
            Revert Updates
          </button>
        }

        @if (statistics().created > 0) {
          <button
            type="button"
            class="white gray small"
            (click)="exportResults()"
          >
            <i class="fa-regular fa-download"></i>
            Export Results
          </button>
        }
      </div>

      <div class="action-buttons">
        <button
          type="button"
          class="alt"
          (click)="onGoBack()"
        >
          <i class="fa-regular fa-chevron-left"></i>
          Upload New CSV
        </button>

        <button
          type="button"
          class="green"
          (click)="onClose(statistics().created)"
        >
          @if (currentService.isProcessing()) {
            <span>Stop & Close</span>
          } @else {
            <span>Done</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>

@if (editingTile) {
  <motn-tile-editor
    [tileId]="editingTile"
    (closed$)="onTileEditorClosed()"
  ></motn-tile-editor>
}
